<template>
    <div class="general-wrapper">
        <Header>
            <template #title>
                <div class="gap-column-xs title">
                    {{ integration.name }}
                    <BaseBetaToggle v-model="isConnected" v-if="manuallyDisconnectable && isConnected" />
                </div>

            </template>

            <template #actions>
                <slot name="actions" v-if="isConnected" />
            </template>
        </Header>

        <slot v-if="isConnected" />
        <PageContainer v-else>
            <div class="integration-card">
                <div class="integration-logo">
                    <img :src="integration.logo_image ||
                        '/icons/integration-logo-placeholder.png'">
                </div>
                <div class="gap-row-1xs w-100 integration-titles">
                    <div class="gap-row-2xs">
                        <div class="qrw-heading-xl qrw-text-content-base-primary">
                            {{ integrationName }}
                        </div>
                        <div class="qrw-heading-xs qrw-text-content-base-secondary">
                            {{ integrationShortDescription }}
                        </div>
                    </div>

                    <div class="qrw-label-sm contact-item">
                        <BaseIcon icon="globe" />
                        <a :href="integration.contacts.website" target="_blank"
                            class="qrw-paragraph-md v1-grey-10-color" v-if="!editing">
                            {{ integration.contacts.website }}
                        </a>
                    </div>
                </div>
                <BasePushButton variant="primary" @click="connectIntegration" icon="plus"
                    bgColor="background-success-default" textColor="content-base-inverse-primary" size="lg">
                    {{ $t("integrations_market.page.connect") }}
                </BasePushButton>
            </div>
        </PageContainer>
    </div>

</template>

<style scoped>
.title {
    align-items: center;
}

.integration-card {
    padding: 24px;
    display: flex;
    flex-direction: row;
    column-gap: 32px;
    background: var(--qrw-background-base-primary);
    box-shadow: var(--qrw-shadow-card-light);
    align-items: center;
}

.integration-logo {
    height: 128px;
    width: 256px;
    max-width: 256px;
    max-height: 128px;
    min-width: 256px;
    max-height: 128px;
    border-radius: 8px;
    position: relative;
    clip-path: border-box;
}

.integration-logo img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.contact-item a {
    text-decoration: none;
    color: var(--qrw-content-link-primary);
}

.integration-titles {
    justify-content: space-between;
    height: 100%;
}

.contact-item {
    align-items: center;
    display: flex;
    column-gap: 4px;
    color: var(--qrw-content-link-primary);
}

.integration-layout-content {
    overflow-y: scroll;
}

.integration-layout-content.disabled {
    opacity: 0.3;
    cursor: not-allowed;
    user-select: none;
    pointer-events: none;
}
</style>

<script>

export default {
    props: {
        tag: String,
        manuallyDisconnectable: {
            type: Boolean,
            default: true
        }
    },
    data () {
        return {}
    },
    methods: {
        connectIntegration () {
            if (
                this.integration.platform_options &&
                this.integration.platform_options.connect_url
            ) {
                window.location.href = this.integration.platform_options.connect_url;
                return;
            }

            this.isConnected = true;
        },
        disconnectIntegration () {
            if (
                this.integration.platform_options &&
                this.integration.platform_options.disconnect_url
            ) {
                window.location.href = this.integration.platform_options.disconnect_url;
                return;
            }

            this.isConnected = false;
        }
    },
    computed: {
        integration () {
            return this.$store.getters['integrations/findByTag'](this.tag);
        },
        integrationLocalizedInfo () {
            const defaultInfo = {
                name: this.integration.name,
                description: this.integration.description,
                short_description: this.integration.short_description,
            };

            if (!this.integration.i18n) return defaultInfo;

            const i18n = this.integration.i18n[this.$i18n.locale];

            if (!i18n) return defaultInfo;

            return {
                name: i18n.name || defaultInfo.name,
                description: i18n.description || defaultInfo.description,
                short_description:
                    i18n.short_description || defaultInfo.short_description,
            };
        },
        integrationShortDescription () {
            return this.integrationLocalizedInfo.short_description;
        },
        integrationDescription () {
            return this.integrationLocalizedInfo.description;
        },
        integrationName () {
            return this.integrationLocalizedInfo.name;
        },
        isConnected: {
            get () {
                return this.$store.getters['integrations/isConnectedByTag'](this.tag);
            },
            set (value) {
                if (value) {
                    this.$store.dispatch('integrations/connectIntegration', this.integration);
                } else {
                    this.$store.dispatch('integrations/disconnectIntegration', this.integration);
                }
            }
        }
    }
}
</script>